import React from "react"
import styled, { keyframes } from "styled-components"
import { Icon } from "antd"

const show = keyframes`
  0% {
    left: 0;
  }

  100% {
    left: 100%;
  }
`

const Hide = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  background: white;
  height: 100%;
  animation: ${show} 0.3s ease-out;
  animation-fill-mode: both;
`

const Wrapper = styled.div`
  position: relative;
  overflow: hidden;
`

export default () => (
  <Wrapper>
    <Hide />
    <Icon
      component={() => (
        <svg width="18px" height="14px" viewBox="0 0 18 14" version="1.1">
          <g
            id="Form"
            stroke="none"
            strokeWidth="1"
            fill="none"
            fillRule="evenodd"
          >
            <g
              id="TextInput"
              transform="translate(-496.000000, -323.000000)"
              fill="#28AD56"
            >
              <g id="Numberinput" transform="translate(283.000000, 311.000000)">
                <g id="ic_check" transform="translate(210.000000, 7.000000)">
                  <g id="Icon-24px">
                    <polygon
                      id="Shape"
                      points="9 16.17 4.83 12 3.41 13.41 9 19 21 7 19.59 5.59"
                    />
                  </g>
                </g>
              </g>
            </g>
          </g>
        </svg>
      )}
    />
  </Wrapper>
)
